<script setup>
import {ref, watch} from "vue";
import {usePage} from '@inertiajs/vue3';

const props = defineProps({
    variant: Object
})

const variants = defineModel('variants')
const submitForm = defineModel('submitForm')
const formData = ref({
    customizableMonth: '',
    customizableYear: '',
    customizableName: '',
    customizableImage: null,
    customizableTemplate: '',
})

const errors = ref({})

const page = usePage()
watch(() => page.props.errors, (newErrors) => {
    if (newErrors && newErrors['items.0.metadata.customizableImage']) {
        errors.value.customizableImage = newErrors['items.0.metadata.customizableImage']
    }
}, { deep: true })

const updateVariantAsync = async () => {
    return new Promise((resolve) => {
        // Não incluir o objeto errors no metadata
        variants.value[0].metadata = {
            customizableMonth: formData.value.customizableMonth,
            customizableYear: formData.value.customizableYear,
            customizableName: formData.value.customizableName,
            customizableImage: formData.value.customizableImage,
            customizableTemplate: formData.value.customizableTemplate
        };
        submitForm.value = false;
        resolve();
    });
};

watch(submitForm, async (newValue) => {
    if (newValue) {
        await updateVariantAsync();
    }
});

watch(() => formData.value.customizableImage, () => {
    errors.value.customizableImage = null
})

defineExpose({
    updateVariantAsync,
});

const months = [
    {title: 'Janeiro', value: 1},
    {title: 'Fevereiro', value: 2},
    {title: 'Março', value: 3},
    {title: 'Abril', value: 4},
    {title: 'Maio', value: 5},
    {title: 'Junho', value: 6},
    {title: 'Julho', value: 7},
    {title: 'Agosto', value: 8},
    {title: 'Setembro', value: 9},
    {title: 'Outubro', value: 10},
    {title: 'Novembro', value: 11},
    {title: 'Dezembro', value: 12}
];

const templates = [
    { title: '10 Anos', value: 10 },
    { title: '15 Anos', value: 15 },
    { title: '20 Anos', value: 20 },
    { title: '25 Anos', value: 25 },
    { title: '30 Anos', value: 30 },
    { title: '35 Anos', value: 35 },
    { title: '40 Anos', value: 40 },
    { title: '45 Anos', value: 45 },
    { title: '50 Anos', value: 50 },
    { title: '55 Anos', value: 55 },
    { title: '60 Anos', value: 60 },
];

const currentYear = new Date().getFullYear();
const years = ref([]);

for (let i = currentYear - 5; i <= currentYear + 5; i++) {
    years.value.push({title: i.toString(), value: i});
}
</script>

<template>
    <v-container>
        <v-form @update:modelValue="updateVariant">
            <v-row>
                <v-col md="6">
                    <v-select
                        label="Mês"
                        :items="months"
                        item-title="title"
                        item-value="value"
                        v-model="formData.customizableMonth"
                    />
                </v-col>
                <v-col md="6">
                    <v-select
                        label="Ano"
                        :items="years"
                        item-title="title"
                        item-value="value"
                        v-model="formData.customizableYear"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col md="6">
                    <v-text-field
                        label="Corretora"
                        v-model="formData.customizableName"
                    />
                </v-col>
                <v-col md="6">
                    <v-select
                        label="Modelo"
                        :items="templates"
                        item-title="title"
                        item-value="value"
                        v-model="formData.customizableTemplate"
                    />
                </v-col>
                <v-col md="6">
                    <v-file-input
                        label="Selecione sua logo"
                        clearable
                        counter
                        persistent-hint
                        v-model="formData.customizableImage"
                        :error-messages="errors.customizableImage"
                    />
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>

<style scoped>

</style>